import { Box, FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material"
import { DateRangePicker, SingleInputDateRangeField } from "@mui/x-date-pickers-pro"
import { shortcuts } from "../../utils/Dates"
import { useTranslation } from "react-i18next"
import { useContext, useState } from "react"
import { LoadingButton } from "@mui/lab"
import { Context as TimeContext } from '../table/timecard/Context'
import { Context as EmplContext } from '../table/employees/Context'
import { Context as ScheContext } from '../table/schedule/Context'
import { Context as OverContext } from '../table/overtime/Context'
import { Context as RequContext } from '../table/requests/Context'
import { gettingAudit } from "../../utils/Audits"

const Context = {
    employees: EmplContext,
    schedule: ScheContext,
    timecard: TimeContext,
    overtime: OverContext,
    request: RequContext,
}

// Audit
const FilterA = ({view}) => {
    const { t } = useTranslation('filter')
    const { t: tUtils } = useTranslation('utils')

    const [type, setType] = useState(view)

    const {
        range2,
        setRange2,
        search,
        setSearch,
        setAudit,
        loadingGettingAudit,
        setLoadingGettingAudit,
    } = useContext(Context[view])

    return (
        <>
            <Box
                sx={{
                    display: 'flex', 
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    gap: 2,
                    p: 1.5,
                    borderBottom: theme => `1px solid ${theme.palette.divider}`, 
                }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <DateRangePicker
                            label={t('filter_audits.range_of_days')}
                            slots={{ field: SingleInputDateRangeField }}
                            slotProps={{
                                shortcuts: {
                                    items: shortcuts(tUtils),
                                },
                            }}
                            format={JSON.parse(sessionStorage.getItem('config')).date_format}
                            calendars={1}
                            fullwith
                            onAccept={(value) => { setRange2(value) }}
                            value={range2}
                            sx={{
                                width: '100%'
                            }}
                        />
                    </Grid>

                    <Grid item xs={3}>
                        <FormControl fullWidth>
                            <InputLabel id="lsb">{t('filter_audits.search_by')}</InputLabel>
                            <Select
                                labelId="lsb"
                                id="sb"
                                value={search}
                                label={t('filter_audits.search_by')}
                                onChange={(event) => { setSearch(event.target.value) }}
                            >
                                <MenuItem value={'audit_date'}>{t('filter_audits.audit_date')}</MenuItem>
                                <MenuItem value={'event_date'}>{t('filter_audits.event_date')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    
                    <Grid item xs={3}>
                        <FormControl fullWidth>
                            <InputLabel id="lv">{t('filter_audits.view')}</InputLabel>
                            <Select
                                labelId="lv"
                                id="v"
                                value={type}
                                label={t('filter_audits.view')}
                                onChange={(event) => { setType(event.target.value) }}
                            >
                                <MenuItem value={'employees'}>{t('filter_audits.titles.employees')}</MenuItem>
                                <MenuItem value={'timecard'}>{t('filter_audits.titles.timecard')}</MenuItem>
                                <MenuItem value={'request'}>{t('filter_audits.titles.request')}</MenuItem>
                                <MenuItem value={'schedule'}>{t('filter_audits.titles.schedule')}</MenuItem>
                                <MenuItem value={'overtime'}>{t('filter_audits.titles.overtime')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={2}>
                        <LoadingButton
                            sx={{position: 'absolute', right: '15px', height: '56px'}} 
                            loading={loadingGettingAudit}
                            variant='contained'
                            onClick={() => {
                                gettingAudit(
                                    setLoadingGettingAudit,
                                    JSON.parse(sessionStorage.getItem('account'))?.id,
                                    range2,
                                    search,
                                    type,
                                    setAudit,
                                )
                            }}
                            disableElevation
                        >
                            {t('filter_audits.search')}
                        </LoadingButton>
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}

export { FilterA }